import { render } from "./Footer.vue?vue&type=template&id=67e26324&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=67e26324&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-67e26324"

export default script